import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum {
  PRECISA_DE_ALGUMA_COISA = 'PRECISA_DE_ALGUMA_COISA',
  BRINCANDO = 'BRINCANDO',
  ALIMENTACAO = 'ALIMENTACAO',
  TROCA_FRALDAS = 'TROCA_FRALDAS',
  LENDO_HISTORIA = 'LENDO_HISTORIA',
  FALANDO = 'FALANDO',
}

export interface ConsultaSeguimentoPergunta14Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_14_HEADER?: SimNaoEnum
  PERGUNTA_14_DEU_EXEMPLO_ABAIXO?: SimNaoEnum
  PERGUNTA_14_OLHA_SEUS_OLHOS?: Record<ConsultaSeguimentoPergunta14OlhaSeusOlhosEnum, SimNaoEnum>
  PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS?: SimNaoEnum
  PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES?: SimNaoEnum
}
